import { useContext } from 'react';
import { MentorStatus } from '../../api/mentors';
import { useFoundersContext } from '../../contexts/founders-context';
import { UserContext } from '../../contexts/user-context';
import ChangeStatusModal from '../common/change-status-modal';

function FounderArchiveModal() {
  const { hasAccessToAction } = useContext(UserContext);
  const {
    isChangingFounderStatus,
    archiveTargetFounders,
    changeFounderStatus,
    setArchiveTargetFounders,
  } = useFoundersContext();

  const length = archiveTargetFounders?.length || 0;

  return hasAccessToAction('founder.details.update') ? (
    <ChangeStatusModal
      open={!!archiveTargetFounders}
      title={'Archive founders'}
      text={`Do you really want to archive ${length} ${
        length === 1 ? 'founder' : 'founders'
      }?`}
      loading={isChangingFounderStatus}
      onClose={() => setArchiveTargetFounders(null)}
      onSubmit={() => changeFounderStatus(MentorStatus.ARCHIVED)}
    />
  ) : null;
}

export default FounderArchiveModal;
